/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_temp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why isn't 0°F equal to 0°C?`)
};

const es_uc_temp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué 0°F no es igual a 0°C?`)
};

const de_uc_temp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum ist 0°F nicht gleich 0°C?`)
};

const nl_uc_temp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom is 0°F niet gelijk aan 0°C?`)
};

const fr_uc_temp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi 0°F n'est-il pas égal à 0°C ?`)
};

const it_uc_temp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché 0°F non è uguale a 0°C?`)
};

const pt_br2_uc_temp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que 0°F não é igual a 0°C?`)
};

const pt_uc_temp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que 0°F não é igual a 0°C?`)
};

const ja_uc_temp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0°Fが0°Cと等しくないのはなぜですか?`)
};

const zh_uc_temp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_temp_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_temp_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_temp_faq1_q", locale)
	if (locale === "en") return en_uc_temp_faq1_q(inputs)
	if (locale === "es") return es_uc_temp_faq1_q(inputs)
	if (locale === "de") return de_uc_temp_faq1_q(inputs)
	if (locale === "nl") return nl_uc_temp_faq1_q(inputs)
	if (locale === "fr") return fr_uc_temp_faq1_q(inputs)
	if (locale === "it") return it_uc_temp_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_temp_faq1_q(inputs)
	if (locale === "pt") return pt_uc_temp_faq1_q(inputs)
	if (locale === "ja") return ja_uc_temp_faq1_q(inputs)
	return zh_uc_temp_faq1_q(inputs)
};